import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    width: '100%',
    height: '400px',
    minHeight: '70%',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
